export default __webpack_public_path__ + "static/media/004-acid rain.bd720cfb.svg";